












import { Vue, Component } from 'vue-property-decorator';
import site from '@/store/modules/site';

@Component
export default class SettingsSidebar extends Vue {
  get isSidebarOptionsOpened(): boolean {
    console.log(this); // eslint-disable-line no-console
    return !site.isSidebarOptionsCollapsed;
  }
}
